import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string.isRequired,
  callback: PropTypes.func,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  complete: PropTypes.bool,
  shortify: PropTypes.number,
};

function Tab(props) {

    let title = props.title;
    let callback = props.callback ? props.callback : null;
    let disabled = props.disabled ? props.disabled : false;
    let active = props.active ? props.active : false;
    let complete = props.complete ? props.complete : false;
    let shortify = props.shortify ? props.shortify : 0;

    return (

      <div className={`link-top text-center ${active ? 'active' : ''} ${disabled ? 'disabled' : ''} ${complete ? 'success' : ''}`}
      { ... callback && {'onClick': (e) => callback(e)} }
      >
          <a className={`cur-p ${shortify && "md-shortify"}`}
          {... shortify && {'data-maxlength' : shortify} }
          >
            { complete && <Fragment><i className="far fa-check"></i>&nbsp;</Fragment> }
            { title }
          </a>
      </div>
    )
}

Tab.propTypes = propTypes;

export default Tab;